import { DeviceRegistryCommandKey } from '@tryiris-ai/common.protojs/api/v1/device_settings';
import type { Mode } from './types.js';
import { locateProxy } from '#~/agent/index.js';
import { StudioError } from '#~/error/index.js';

/**
 * Toggle the focus mode.
 *
 * @param deviceId - The ID of the device whose focus mode is to be toggled.
 */
export const mode: Mode = async (deviceId) => {
  try {
    const proxy = locateProxy(deviceId);

    if (!proxy) {
      throw new Error('FM-3KU');
    }

    const command = DeviceRegistryCommandKey.FOCUS_MODE;
    const settings = proxy.state.status?.device[deviceId]?.deviceSettings?.settings[command];
    const currentValue = settings?.select ?? 0;

    await proxy.mutate(
      {
        control: {
          device: {
            [deviceId]: {
              deviceSettings: {
                [command]: {
                  key: command,
                  select: currentValue === 0 ? 1 : 0
                }
              }
            }
          }
        }
      },
      {}
    );
  } catch (cause) {
    throw new StudioError('Unable to toggle focus mode.', { cause });
  }
};
